<!--
 * @Description: 子订单查询 面单打印
 * @Author: lorry
 * @Date: 2019-10-29 17：46
 * @LastEditTime: 2019-10-29 17：46
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div>
    <el-dialog :title="$lang('子订单面单打印')" :close-on-click-modal="false" width="900px" :visible="printTableVisible" style="padding:0" @close="subDialogClose">
      <div class="btn-print">
        <el-button size="mini" type="primary" :disabled="subSelection.length?false:true" :loading="keyBtn" @click="openMenu()" >
          <i class="icon-iconfont iconfont icondayin"></i><span>{{$lang('面单打印')}}</span></el-button>
      </div>
      <div class="avue-crud" >
        <div class="avue-crud-body">
          <el-table :data="gridData" size="mini" border @selection-change="subSelectionChange" :loading="subLoading" max-height="300">
            <el-table-column
              type="selection"
              width="40">
            </el-table-column>
            <el-table-column type="index" :label="$lang('序号')" width="80"></el-table-column>
            <el-table-column property="subWaybillId" :label="$lang('子单号')"></el-table-column>
            <el-table-column property="inputTime" :label="$lang('录入时间')"></el-table-column>
            <el-table-column property="waybillId" :label="$lang('主单号')"></el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { printOrderSubs } from '@api/module/customer'
import { mapGetters } from 'vuex'
import { getLodop, printImages } from '@/utils/LodopFuncs.js'

export default {
  name: 'SubOrder',
  data() {
    return {
      dialogTableVisible: false,
      radio2: 1,
      textarea: '',
      keyBtn: false,
      subLoading: false,
      subSelection: [],
    }
  },
  props: {
    selectId: {
      type: String,
      default: '',
    },
    printTableVisible: {
      type: Boolean,
      default: false,
    },
    gridData: {
      type: Array,
      require: true,
      default: () => {
        return []
      },
    },
  },
  computed: {
    ...mapGetters(['langList']),
    isChrome() {
      return navigator.userAgent.match(/Chrome\D?\d+/i)
    },
    isIos() {
      return navigator.userAgent.match(/macintosh|mac os x/i)
    },
    isChromeVer() {
      let verChrome = navigator.userAgent.match(/Chrome\D?\d+/i)
      verChrome = verChrome[0].match(/\d+/)
      if (verChrome[0] >= 41) { return true } else { return false }
    },
    // 用户信息
    userInfo() {
      return this.$store.state.base.user || {}
    },
  },
  mounted() {
    setTimeout(() => {
      this.checkIsInstall()
    }, 200)

    setTimeout(() => {
      this.lodop = getLodop()
    }, 500)
  },
  methods: {
    checkIsInstall() {
      try {
        this.LODOP = this.$getLodop()
        this.hasLodop = !!this.LODOP.VERSION
      } catch (err) {
        console.log('print:' + err)
      }
    },
    subDialogClose() {
      this.$emit('dialogClode')
    },
    subSelectionChange(val) {
      this.subSelection = val
    },
    async openMenu() {
      if (this.isIos) {
        this.$message.warning(this.$lang('IOS系统暂不支持安装打印插件, 请使用浏览器打印！'))
        this.toPrint()
        return
      }
      if (!this.isChrome) {
        const tip = '建议使用谷歌浏览器进行打印'
        this.dowmloadChrome(tip)
      } else if (this.isChrome && !this.isChromeVer) {
        const tip = this.$lang('当前谷歌浏览器版本过低，请重新下载并安装')
        this.dowmloadChrome(tip)
      } else {
        if (!this.hasLodop) {
          // 判断是否已经下载过插件
          this.dowmloadZip()
        } else {
          this.selection = []
          if (this.checkPriny()) {
            // this.showLinks(e)
            this.toPrint()
          }
        }
      }
    },
    async toPrint() {
      this.keyBtn = true
      this.$rightMenu.close()
      try {
        this.selection = await this.printSubOrder()
        if (this.selection) {
          if (this.isIos) {
            const url = URL.createObjectURL(this.selection)
            window.open(url)
            this.keyBtn = false
          } else {
            const params = {
              images: [this.selection],
              type: 'stream',
              printerValue: this.prinyValue,
            }
            printImages(params, () => {
              this.keyBtn = false
            })
          }
        }
      } catch (err) {
        this.keyBtn = false
      }
    },
    // 订单打印
    async printSubOrder() {
      const selection = this.subSelection
      if (selection.length > 0) {
        const newArr = selection.map((item, index, selection) => item.subWaybillId)
        const orderSubIds = newArr.join(',')
        const params = { subOrders: orderSubIds, printType: 1, orderId: selection[0].orderId }
        const res = await printOrderSubs(params)
        if (res.type === 'application/pdf') {
          this.$message.success(this.$lang('已生成打印数据，正在打印中...'))
          setTimeout(() => {
            this.subDialogClose()
          }, 1100)
          return res
        } else if (res.type === 'application/json') {
          const reader = new FileReader()
          reader.readAsText(res)
          reader.onload = (event) => {
            const msg = JSON.parse(reader.result).msg || '' // 错误信息
            this.$message.error(this.$lang(msg))
          }
          this.keyBtn = false
          return false
        }
      }
    },
    // 下载谷歌浏览器
    dowmloadChrome(tip) {
      this.$confirm(this.$lang(tip), this.$lang('温馨提示'), {
        confirmButtonText: this.$lang('去下载'),
        cancelButtonText: this.$lang('取消'),
        closeOnClickModal: false,
        type: 'warning',
      }).then(() => {
        const link = document.createElement('a')
        link.target = '_blank'
        link.href = 'https://www.google.cn/chrome/'
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
      }).catch(_ => { })
    },
    // 下载插件
    dowmloadZip() {
      this.$alert(`<p class="downloadZip-p">${this.$lang('请先下载并安装CLodop打印插件，才可进行打印，下载成功后请刷新本页面，并启动CLodop插件。')}</p>
        <a class="downloadZip-a" href="https://vipgw.jtcargo.co.id/print/CLodop-Setup-for-Win32/Lodop6.226Clodop4.142.zip" target="_self">${this.$lang('CLodop_Setup_for_Win32NT.exe')}</a>
        <a class="downloadZip-a" href="https://vipgw.jtcargo.co.id/print/CLodop-Setup-for-Win64/CLodop_Setup_for_Win64NT_4.142EN.zip" target="_self">${this.$lang('CLodop_Setup_for_Win64NT_4.142EN.exe')}</a>`,
      this.$lang('温馨提示'), {
        dangerouslyUseHTMLString: true,
        showConfirmButton: false })
    },
    checkPriny() {
      const targetPrinter = this.userInfo.targetPrinter
      if (!targetPrinter) {
        this.$message.error(this.$lang('请在右上角“我的资料”中进行打印设置默认打印机'))
        return false
      }
      const printCount = this.LODOP.GET_PRINTER_COUNT()
      const printList = []
      // 获取所有打印机的名称
      for (let i = 0; i < printCount; i++) {
        const name = this.LODOP.GET_PRINTER_NAME(i)
        printList.push(name)
      }
      if (!printList.includes(targetPrinter)) {
        this.$message.error(this.$lang('打印机硬件已变更，请在右上角 “我的资料” 中进行打印设置'))
        return false
      } else {
        this.prinyValue = printList.indexOf(targetPrinter)
        this.LODOP.SET_PRINTER_INDEXA(printList.indexOf(targetPrinter))
      }
      return true
    },
  },
}
</script>
<style lang="scss" scoped>
.btn-print{
  margin-bottom: 10px;
}
.avue-crud{
  margin-bottom: 10px;
}
</style>
